import { usersListResponse } from "types/userInfo";
import { getAssetList } from "./assets.api";
import { GetUsers } from "./users.api";
import { AssetListResponse } from "types/asset";
import { random } from "lodash";
import { getUUID } from "utils/utils";
import { DeviceListResponse } from "types/device";
import { getDeviceList } from "./devices.api";

const NUMBER_OF_ROWS = 200

export function getRandomLocation() {
  const building = random(0, 1)
  if (building === 0)
    return {
      "venue": {
        "id": "5e417c00-1023-4ca7-9d1b-0e4ce5c80fca",
        "name": "cumberlandinfirmary"
      },
      "region": {
        "id": "646aea7e-ceb2-4379-8c42-58d46a48b808",
        "name": "A&E Treatment Room 1A-4A",
      },
      "coordinates": {
        "latitude": random(54.89650, 54.89710),
        "longitude": -1 * random(2.9575, 2.9595)
      },
      "uncertainty": 9.153183175800523,
      "is_outdoors": Math.random() < 0.5,
      "building_level": {
        "possible_buildings": [
          {
            id: "3cc3c63b-c5e5-471c-891e-9f652965f41b",
            name: "Main"
          }
        ],
        "level": {
          "id": "0e556a57-3efe-425d-aa02-fb19f7b70130",
          "name": "Floor 0",
          "short_name": "0"
        },
      }
    }

  return {
    "venue": {
      "id": "5e417c00-1023-4ca7-9d1b-0e4ce5c80fca",
      "name": "cumberlandinfirmary"
    },
    "region": {
      "id": "ccfdcce0-afb3-4f56-8ab5-7881bbcfda05",
      "name": "Cancer Centre Floor -1",
      "confidence": {
        "source": "99.0",
        "parsedValue": 99
      }
    },
    "coordinates": {
      "latitude": random(54.89640, 54.89670),
      "longitude": -1 * random(2.9562, 2.9568)
    },
    "uncertainty": 6.177809757355032,
    "is_outdoors": Math.random() < 0.5,
    "building_level": {
      "possible_buildings": [
        {
          id: "81cd54dd-bfc4-4c87-b491-1b77ce3dd480",
          name: "Cancer Centre"
        }
      ],
      "level": {
        "id": "7d3f34f7-2125-411f-b0e2-f70ba7af2cb9",
        "name": "Floor -1",
        "short_name": "-1"
      },
      "confidence": {
        "source": "99.0",
        "parsedValue": 99
      }
    }
  }

}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function createMockUsers() {
  const names = ["Alex", "Sam", "Chris", "Taylor", "Jordan", "Riley", "Casey"];
  const users = []
  for (let i = 0; i < 20; i++) {
    users.push({
      user_id: getUUID(),
      location: getRandomLocation(),
      last_update_timestamp: new Date().toISOString(),
      name: names[Math.floor(Math.random() * names.length)],
      email: ''
    })
  }
  return users
}

// eslint-disable-next-line @typescript-eslint/no-unused-vars
function createMockDevices() {
  const ids = ["mobile-1", "mobile-2", "mobile-3", "mobile-4", "mobile-5", "mobile-6", "mobile-7"];
  const devices = []
  for (let i = 0; i < 20; i++) {
    devices.push({
      location: getRandomLocation(),
      last_update_timestamp: new Date().toISOString(),
      device_id: ids[Math.floor(Math.random() * ids.length)],
    })
  }
  return devices
}

export function getMapAssets(venueID: string | null, params?: Record<string, any>): Promise<AssetListResponse> {

  return getAssetList({
    limit: 200,
    has_location_filter: 'true',
    venue_id_filter: venueID,
    ...params
  })
  // .then(res => {
  //   res.items.forEach(r => {
  //     r.last_location_update_timestamp = (new Date()).toDateString()
  //     r.location = getRandomLocation()
  //     r.assigned_beacon = {
  //       id: "test" + random(0, 1000000) + random(0, 1000000),
  //       beacon_type: "",
  //       battery: 100,
  //       import_info: {
  //         import_timestamp: "",
  //         source: "",
  //         order_id: ""
  //       }
  //     }
  //   })
  //   return res
  // })
};

export function getMapUsers(venueID: string | null, params?: Record<string, any>): Promise<usersListResponse> {

  return GetUsers({
    venue_id_filter: venueID,
    ...params,
    limit: NUMBER_OF_ROWS
  })
  // .then(res => {
  //   const users = createMockUsers()
  //   return {
  //     items: users,
  //     next: "",
  //     "count": users.length,
  //     "total": users.length
  //   }
  // })
};

export function getMapDevices(venueID: string | null, params?: Record<string, any>): Promise<DeviceListResponse> {

  return getDeviceList({
    venue_id_filter: venueID,
    ...params,
    limit: NUMBER_OF_ROWS
  })
  // .then(res => {
  //   res.items.forEach(r => {
  //     r.location = getRandomLocation()
  //   })
  //   return res
  // })
};
